import { Typography} from '@material-ui/core';
import { Button,  Divider, Link } from '@mui/material';
import { VolunteerActivism } from '@mui/icons-material';
import './styles.css';

const DonationPrompt = (props) => {
	const {colorMode} = props;

	const colorPicker = (colorMode) => (colorMode === 'dark' ?' #595959' : ' #ffffff')

  return (
		<>
			<div className='donationPromptText'>
				<VolunteerActivism fontSize="large" style={{color: colorPicker(colorMode)}}/>
			</div>
			<Divider variant="middle" style={{borderColor: colorPicker(colorMode), margin: '10px'}}/>
			<Typography className="donationPromptText" style={{color: colorPicker(colorMode)}} variant="body1">Helpful? Please donate!</Typography>
			<div className='donationPromptText'>
				<Link href="https://buymeacoffee.com/violinscope" target="_blank" rel="noopener noreferrer">
					<Button color='secondary' variant='contained' size="small" onClick={() => null}>
						<img
							className="coffeeImage"
							src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
							alt="Buy me a coffee"
						/>
						
						Donate
						
					</Button>
				</Link>
			</div>
		</>
	)

}

export default DonationPrompt;